export enum ResultsTab {
  All = "All",
  Passed = "Passed",
  Refused = "Refused",
  Missing = "Missing",
  Reported = "Reported",
}
